import { getMoney } from '@hlj/hlj-utils'
import style from './style.module.less'

export const leftColumns = [
  {
    dataIndex: 'orderNo',
    title: '合作订单号'
  },
  {
    dataIndex: 'createdAt',
    title: '创建时间'
  },
  {
    dataIndex: 'userName',
    title: '姓名'
  },
  {
    dataIndex: ['property', 'name'],
    title: '需求类型'
  },
  {
    dataIndex: 'totalMoney',
    title: '订单金额',
    render: totalMoney => getMoney(totalMoney)
  }
]

export const rightColumns = [
  {
    dataIndex: ['merchantSupport', 'nick'],
    title: '创建人'
  },
  {
    dataIndex: 'userPhone',
    title: '手机号'
  },
  {
    dataIndex: ['merchant', 'name'],
    title: '商家名'
  },
  {
    dataIndex: 'brokerageSum',
    title: '本单已扣服务费',
    className: style.brokerageSum,
    render: brokerageSum => getMoney(brokerageSum)
  }
]
